import script from "./ChatSettingsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatSettingsModal.vue?vue&type=script&setup=true&lang=js"

import "./ChatSettingsModal.vue?vue&type=style&index=0&id=79529d40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79529d40"]])

export default __exports__